const infobox = {
  color: ({ theme }) => theme.colors.foreground,
  backgroundColor: ({ theme }) => theme.colors.white,
  borderColor: ({ theme }) => theme.colors.lightBorder,
  iconColor: ({ theme }) => theme.colors.foreground,
  br: 0,
}

export default infobox
